import { GenericYakComponentOf } from 'next-yak'

export type YakComponentOf<T extends React.ElementType, P = {}> = T extends keyof React.JSX.IntrinsicElements
  ? GenericYakComponentOf<{}, React.JSX.IntrinsicElements[T] & P>
  : GenericYakComponentOf<T, React.ComponentPropsWithoutRef<T> & P>
